class customTabs extends HTMLElement {
  constructor() {
    super();
    this.tabLinks = this.querySelectorAll('.tablink');
    this.tabContainers = this.querySelectorAll('.tabcontent');

    this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    this.tabLinks.forEach((item, index) => {
      item.addEventListener('click', (e) => { this.handleIndicator(e.target)});
      item.classList.contains('open') && this.handleIndicator(item);
    });
  }

  handleIndicator(el) {
    const indicator = this.querySelector('.nav-indicator');
    if(indicator){
      indicator.style.width = `${el.offsetWidth}px`;
      indicator.style.left = `${el.offsetLeft}px`;
    }
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
  toggleTabs(event){
    event.preventDefault();
    event.stopPropagation();
    const currentTab = event.currentTarget;
    const tabLink = currentTab.querySelector('[data-toggle="tab"]');
    const tabContainer = document.querySelector(tabLink.dataset.tabcontent);

    this.openTab(currentTab, tabContainer)
  }

  /**
   * Open Tab Container
   *
   * @param {Node} currentTab Tab Container Open link
   * @param {Node} tabContainer Tab Container to open
   */
  openTab(currentTab, tabContainer) {
    this.tabContainers.forEach(container => {
      container.classList.remove('open');
      const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
      if(linkEle){
        linkEle.setAttribute('aria-expanded', false);
        if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
      }
    });
    currentTab.classList.add('open');
    currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
    tabContainer.classList.add('open');
  }
}
customElements.define("custom-tabs", customTabs);
